// A/B experiment to show Extend on HuskyLiners (UWP-14142)
export function useExtendExperiment() {
  const amplitude = useAmplitude()

  // Set to true so all sites are in the experiment by default
  const isInExperiment = useState('extendHuskyABTest', () => true)

  // If the experiment runs then opt out of the experiment if not in treatment
  amplitude.onReady({
    experimentId: 'extend-warranty',
    callback: (variant) => {
      if (variant.value !== 'treatment') isInExperiment.value = false
    },
  })

  return {
    isInExperiment: readonly(isInExperiment),
  }
}
